import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Card, Spinner } from 'react-bootstrap';

const DashboardKpiCard = ({
  title,
  value,
  detail,
  icon,
  accent = 'primary',
  footer,
  loading = false
}) => {
  return (
    <Card className="h-100 border-0 shadow-sm">
      <Card.Body className="p-3">
        <div className="d-flex align-items-start justify-content-between gap-3">
          <div className="min-w-0">
            <p className="text-600 fs--1 fw-semi-bold mb-1">{title}</p>
            {loading ? (
              <div
                className="d-flex align-items-center"
                style={{ minHeight: '2rem' }}
              >
                <Spinner
                  animation="border"
                  size="sm"
                  variant={accent}
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <div className="fs-2 fw-semi-bold text-900 lh-1">{value}</div>
            )}
          </div>
          {icon && (
            <span className={`text-${accent} fs-1 lh-1 flex-shrink-0`}>
              <FontAwesomeIcon icon={icon} />
            </span>
          )}
        </div>
        {detail && <p className="text-700 fs--1 mt-2 mb-0">{detail}</p>}
        {!loading && footer && (
          <p className="text-500 fs--2 mt-1 mb-0">{footer}</p>
        )}
      </Card.Body>
    </Card>
  );
};

DashboardKpiCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  detail: PropTypes.string,
  icon: PropTypes.any,
  accent: PropTypes.string,
  footer: PropTypes.string,
  loading: PropTypes.bool
};

export default DashboardKpiCard;
